/**
 * Actiones que se realizan sobre los tipos incidencias
 * @type {string[]}
 */
TiposUniGesActionsService.$inject = ['$log', 'dialogService', '$http'];
export default function TiposUniGesActionsService($log, dialogService, $http) {

    var URL_TIPOS_BASE = Sigo.var.path + '/mantenimiento/tipos-uniges';
    var DIALOG_ADD_ASIGNACION_TEMPLATE = require('./tipAsigAddDialog.html');
    var DIALOG_ADD_ASIGNACION_ID = 'dialogTipo';

    function _addUsuarioToTipo(idvTUniGes, rol) {
        var titulo = 'Añadir usuario';
        var url = URL_TIPOS_BASE + '/anyadiratipo/' + idvTUniGes + '/usuario/' + rol;
        return _getAnyadirResponsable(url, titulo, rol, "usuario");
    }

    function _addEntidadToTipo(idvTUniGes, rol) {
        var titulo = 'Añadir entidad';
        var url = URL_TIPOS_BASE + '/anyadiratipo/' + idvTUniGes + '/entidad/' + rol;
        return _getAnyadirResponsable(url, titulo, rol, "entidad");
    }

    function _addGrupoToTipo(idvTUniGes, rol) {
        var titulo = 'Añadir grupo';
        var url = URL_TIPOS_BASE + '/anyadiratipo/' + idvTUniGes + '/grupo/' + rol;
        return _getAnyadirResponsable(url, titulo, rol, "grupo");
    }

    function _getAnyadirResponsable(url, titulo, rol, tipo) {
        return $http.get(url)
            .then(function (data) {
                var res = data.data;
                if (rol == 'responsable') res.esTipoPadre = false;
                if (Array.isArray(res.disponibles) && res.disponibles.length > 0)
                    res.seleccionado = res.disponibles[0];

                var options = {title: titulo};
                var extraOptions = {
                    botonOk: ucfirst(Lang.get('nombres.confirmar')),
                    botonCancel: ucfirst(Lang.get('nombres.cancelar'))
                };

                return dialogService.open(DIALOG_ADD_ASIGNACION_ID, DIALOG_ADD_ASIGNACION_TEMPLATE, res, options, extraOptions);

            }).then(function (result) {
                var id = result.seleccionado.id;
                var urlPost = url + '/' + id;
                if (issetAndNotEmpty(result.anyadir_en_hijos) && result.anyadir_en_hijos) urlPost += '?anyadir_en_hijos=true';
                return $http.post(urlPost);
            });
    }

    return {
        addUsuarioToTipo: _addUsuarioToTipo,
        addEntidadToTipo: _addEntidadToTipo,
        addGrupoToTipo: _addGrupoToTipo
    }
}